console.log("Script ugacountdown");

document.addEventListener('DOMContentLoaded', function () {
    const countdownContainers = document.querySelectorAll('.uga__countdown__container');
    if (countdownContainers.length > 0) {
        const htmlLang = document.documentElement.lang || 'fr';

        countdownContainers.forEach(container => {
            const eventDateElement = container.querySelector('.uga__eventDate');
            const eventDate = eventDateElement ? eventDateElement.value : null;

            if (eventDate) {
                if (isValidDate(eventDate)) {
                    addCountdown(container, eventDate, htmlLang);
                } else {
                    displayMessage(container, htmlLang, "invalid");
                }
            }
        });
    }
});

function isValidDate(dateString) {
    const date = new Date(dateString);
    return date instanceof Date && !Number.isNaN(date.getTime());
}

function addCountdown(container, targetDate, lang) {
    let interval;
    let lastMinute = -1;

    function updateCountdown() {
        const now = new Date().getTime();
        const target = new Date(targetDate).getTime();
        const distance = target - now;

        if (distance < 0) {
            clearInterval(interval);
            displayMessage(container, lang, "expired");
            resetCountdown(container);
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        updateCountdownDisplay(container, { days, hours, minutes, seconds });

        // Annonce initiale au premier tick
        if (lastMinute === -1) {
            updateLiveRegion(container, { days, hours, minutes });
        }
        lastMinute = minutes;
    }

    function resetCountdown(container) {
        container.querySelector('.uga__days span').innerText = '00';
        container.querySelector('.uga__hours span').innerText = '00';
        container.querySelector('.uga__minutes span').innerText = '00';
        container.querySelector('.uga__seconds span').innerText = '00';
    }

    updateCountdown();
    interval = setInterval(updateCountdown, 1000);
}

function updateCountdownDisplay(container, timeValues) {
    container.querySelector('.uga__days span').innerText = timeValues.days;
    container.querySelector('.uga__hours span').innerText = formatTime(timeValues.hours);
    container.querySelector('.uga__minutes span').innerText = formatTime(timeValues.minutes);

    const secondsElement = container.querySelector('.uga__seconds span');
    secondsElement.innerText = formatTime(timeValues.seconds);

    secondsElement.classList.remove('animate');
    void secondsElement.offsetWidth;
    secondsElement.classList.add('animate');

    // Mise à jour aria-live uniquement à chaque nouvelle minute
    if (timeValues.seconds === 0) {
        updateLiveRegion(container, timeValues);
    }
}

function updateLiveRegion(container, timeValues) {
    const liveRegion = container.querySelector('.uga__countdown__live');
    if (!liveRegion) return;

    const lang = document.documentElement.lang || 'fr';
    const parts = [];

    if (timeValues.days > 0) {
        parts.push(`${timeValues.days} ${lang === 'en' ? 'days' : lang === 'it' ? 'giorni' : 'jours'}`);
    }
    if (timeValues.hours > 0) {
        parts.push(`${timeValues.hours} ${lang === 'en' ? 'hours' : lang === 'it' ? 'ore' : 'heures'}`);
    }
    parts.push(`${timeValues.minutes} ${lang === 'it' ? 'minuti' : 'minutes'}`);

    liveRegion.innerText = parts.join(', ');
}

function formatTime(time) {
    return time < 10 ? '0' + time : time;
}

function displayMessage(container, lang, messageType) {
    const messageElement = container.querySelector('.uga__countdown__message');
    const messages = {
        expired: {
            fr: "Le compte à rebours est terminé.",
            en: "The countdown is over.",
            it: "Il conto alla rovescia è finito."
        },
        invalid: {
            fr: "Date invalide.",
            en: "Invalid date.",
            it: "Data non valida."
        }
    };

    const message = (messages[messageType] && messages[messageType][lang]) || messages[messageType]['fr'];
    if (messageElement) messageElement.innerText = message;
}